import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {
  public currentYear: number;

  constructor() { }

  ngOnInit(): void {
    const date = new Date();
    this.currentYear = date.getFullYear();
  }

}
